import { render, staticRenderFns } from "./TaskStatusInfo.vue?vue&type=template&id=2472b65c&scoped=true&"
import script from "./TaskStatusInfo.vue?vue&type=script&lang=js&"
export * from "./TaskStatusInfo.vue?vue&type=script&lang=js&"
import style0 from "./TaskStatusInfo.vue?vue&type=style&index=0&id=2472b65c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2472b65c",
  null
  
)

export default component.exports